<template>
  <div class="col-md-7">
         <Table 
              :columns="columns"
              size="small"
              :data="resources"
              :loading="loading"
              max-height="700"
              highlight-row
              stripe>
            <template slot-scope="{row}" slot="uom" >{{ 
              row.u_o_m ?
              row.u_o_m.uom_name_en 
              : null
              }}
            </template>
            <template slot-scope="{row}" slot="salecode">{{ 
            row.sale_code?
            row.sale_code
            :null
            }}
            </template>     
            <template slot-scope="{row}" slot="quantityInHand">{{ 
            row.product_price?
            row.product_price.quantity_in_hand
            :null
            }}
            </template>
            <template slot-scope="{row}" slot="costprice">{{ 
            row.product_price?
            parseFloat( row.product_price.cost).toFixed(2)
            :null
            }}    
            </template>
            <template slot-scope="{row}" slot="saleprice">{{ 
            row.product_price?
            parseFloat( row.product_price.sale_price).toFixed(2)
            :null
            }}
            </template>
          </Table>
  </div>
</template>

<script>
  export default {
    name:'table-expand',
    props: {
      row: Object
    },
    computed:{
      resources(){
        return this.row.sale_code
      },
    columns () {
      return [
        {
          title:this.$t('product.uom'),
          slot:'uom',
          minWidth: 150,
        },
        {
          title:this.$t('product.salecode'),
          slot:'salecode',
          minWidth: 150,
        },
        {
          title:this.$t('product.quantityInHand'),
          slot:'quantityInHand',
          align: 'center',
          minWidth: 200,
        },
        {
          title:this.$t('product.costprice'),
          slot:'costprice',
          align: 'center',
          minWidth: 150,
        },
        {
          title:this.$t('product.saleprice'),
          slot:'saleprice',
          align: 'center',
          minWidth: 150,
        },
      ]
    }
    }
  };
</script>
